export default __webpack_public_path__ + "static/media/NFSe.b3421e35.svg";